import { ConsumableDTO, MenuDTO } from './ConsumableDTO'
import { VoucherDTO } from './VoucherDTO'
import { ModifierGroupDTO } from './ModifierDTO'

export class ProductLibraryDTO {
    constructor(
        public id: string,
        public venueId: string,
        public consumables: ConsumableDTO[],
        public menus: MenuDTO[],
        public vouchers: VoucherDTO[],
        public modifierGroups: ModifierGroupDTO[]
    ) { }
}
